import { onCLS, onFCP, onLCP, onTTFB, onINP, type Metric } from 'web-vitals';

/**
 * Registers Web Vitals performance metric callbacks.
 *
 * If no callback is provided, no metrics are reported.
 *
 * @param onPerfEntry - Callback invoked for each collected web-vitals metric.
 */
export function reportWebVitals(onPerfEntry?: (metric: Metric) => void): void {
  if (!onPerfEntry) return;

  onCLS(onPerfEntry);
  onFCP(onPerfEntry);
  onLCP(onPerfEntry);
  onTTFB(onPerfEntry);
  onINP(onPerfEntry);
}

export default reportWebVitals;